export default "__VITE_ASSET__23jdSL0L__"